import analytics from '@/utils/baidu-analytics';


export const initXesAnalytics = (isDev) => {
  if (typeof XesAnalytics === 'undefined') return;
  // eslint-disable-next-line no-undef
  XesAnalytics.init({
    source: '8',
    event_env: isDev ? 'test' : 'prod',
    proj_id: '156', // 必传
    autoTrack: false,
  });
};

// 获取浏览器版本
function getBrowerVersion() {
  const ua = navigator.userAgent;
  const is360 = !navigator.userActivation;
  let tem;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*([\d.]+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return `IE ${tem[1] || ''}`;
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return tem
        .slice(1)
        .join(' ')
        .replace('OPR', 'Opera');
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if (M[0] === 'Chrome') {
    M[0] = is360 ? '360浏览器' : M[0];
  }
  // eslint-disable-next-line no-cond-assign
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(' ');
}


// 处理点击事件埋点
// eslint-disable-next-line max-len
export const setClickBuryingPoint = (currentComponent, eventId, usrProps, businessProps = {}) => {
  if (typeof XesAnalytics === 'undefined') {
    analytics.trackEvent({
      category: 'xes_analytics',
      action: `${eventId}_${businessProps}`,
      opt_label: 'fail_loaded',
    });
    return;
  }
  Object.keys(usrProps).forEach((key) => {
    if (typeof usrProps[key] === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      usrProps[key] = '-';
    }
  });
  Object.keys(businessProps).forEach((key) => {
    if (typeof businessProps[key] === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      businessProps[key] = '-';
    }
  });
  // eslint-disable-next-line no-undef
  XesAnalytics.setProfile({

    age: '',

    app_id: '',

    bind_phone: '',

    city: '',

    city_id: '',

    gid: '',

    grade: '',

    grade_id: '',

    open_id: '',

    province: '',

    sex: '',

    stu_id: '',

    uid: '',

    union_id: '',

    user_id: currentComponent.$store.state.user.userInfo.id,

    user_name: currentComponent.$store.state.user.userInfo.username,

    ...usrProps,
  }, );
  // eslint-disable-next-line no-undef
  XesAnalytics.track(
    eventId, {
      // 自定义事件属性
      browser_version: getBrowerVersion(),
      ...businessProps,
    },
  );
};


// eslint-disable-next-line max-len
export const setViewBuryingPoint = (currentComponent, eventId, usrProps, businessProps = {}) => {
  if (typeof XesAnalytics === 'undefined') {
    analytics.trackEvent({
      category: 'xes_analytics',
      action: `${eventId}_${businessProps}`,
      opt_label: 'fail_loaded',
    });
    return;
  }
  Object.keys(usrProps).forEach((key) => {
    if (typeof usrProps[key] === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      usrProps[key] = '-';
    }
  });
  Object.keys(businessProps).forEach((key) => {
    if (typeof businessProps[key] === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      businessProps[key] = '-';
    }
  });
  // eslint-disable-next-line no-undef
  XesAnalytics.setProfile({

    age: '',

    app_id: '',

    bind_phone: '',

    city: '',

    city_id: '',

    gid: '',

    grade: '',

    grade_id: '',

    open_id: '',

    province: '',

    sex: '',

    stu_id: '',

    uid: '',

    union_id: '',

    user_id: currentComponent.$store.state.user.userInfo.id,

    user_name: currentComponent.$store.state.user.userInfo.username,


    ...usrProps,
  }, );
  // eslint-disable-next-line no-undef
  XesAnalytics.view(
    eventId, {
      // 自定义事件属性
      browser_version: getBrowerVersion(),
      ...businessProps,
    },
  );
};


export default {};
